import React, { useState, useEffect, useRef } from "react";
import Leaderboard from '@mui/icons-material/Leaderboard';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { useNavigate, useParams } from "react-router-dom";
import AppTopBar2 from "./common/app-top-bar2";
import AppLoading from "./common/app-loading";
import OutlinedInput from '@mui/material/OutlinedInput';
import PopReportCard from '../components/report-card/pop-report-card';
import PopDraftPreview from './pop-draft-preview';
import {
  Avatar,
  AppBar,
  Button,
  Box,
  Card,
  CardActions,
  CardContent,
  Chip,
  ClickAwayListener, 
  Fab,
  Container,
  Divider,
  Drawer,
  TablePagination,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper, 
  Select,
  Toolbar,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Grid,
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  TableSortLabel,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { AppHelper } from "../AppHelper";
import { EssayHelper } from "../helpers/essay.helper";
import EssayView from "./essay/essay-view";
import PopResubmit from './common/pop-resubmit';
import SpaCheck from "./common/spa-check";
const dayjs = require("dayjs");

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box>
        <Typography
          variant="body2"
          color="text.secondary"
          fontSize={"0.7rem"}
          sx={{
            color: props.recSelected == 1 ? "#fff" : "text.secondary",
          }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const headCellsEssay = [
  { id: "rowIndex", numeric: true, disablePadding: false, label: "#" },
  { id: "grade", numeric: false, disablePadding: false, label: "GRADE" },
  { id: "topic", numeric: false, disablePadding: false, label: "TITLE" },
  { id: "improvedFlag", numeric: false, disablePadding: false, label: "IMPROVED" },
  { id: "avgScore", numeric: true, disablePadding: false, label: "SCORE" },
  { id: "version", numeric: true, disablePadding: false, label: "VERSION" },
  { id: "tCode", numeric: false, disablePadding: false, label: "SUBMITTED ON" },
  { id: "name", numeric: false, disablePadding: false, label: "SUBMITTED BY" },
  { id: "essayId", numeric: false, disablePadding: false, label: "" },
];


function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = headCellsEssay;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function PageSaEssayListV2() {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();
  const { pageEssayId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [essayList, setEssayList] = useState([]);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [viewMode, setViewMode] = React.useState("LIST");
  const [refreshList, setRefreshList] = React.useState(false);
  const [recEssay, setRecEssay] = React.useState({});
  const [autoSelectId, setAutoSelectId] = React.useState("");
  const [countEssay, setCountEssay] = React.useState(0);

  const [tblOrderEssay, setTblOrderEssay] = React.useState("desc");
  const [tblOrderByEssay, setTblOrderByEssay] = React.useState("tCode");
  const [filterEssay, setFilterEssay] = React.useState("");
  const [selectedProfileId, setSelectedProfileId] = useState("");
  const [selectedProfileName, setSelectedProfileName] = useState("");
  const [isPopReportCardOpen, setIsPopReportCardOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [statusFilter, setStatusFilter] = React.useState("all");
  const [essayId, setEssayId] = useState("");
  const [popResubmitOpen, setPopResubmitOpen] = useState(false);
  const [openDraftPreview, setOpenDraftPreview] = useState(false);
  const gradeList = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2', 'S3', 'S4', 'S4E', 'S5'];
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [filterByDate, setFilterByDate] = useState(false);
  const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
  const [endDate, setEndDate] = useState(dayjs());
  const [dateRange, setDateRange] = React.useState([dayjs().subtract(7, 'day'), dayjs()]);
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleCloseCalendar = () => {
    setOpen(false);
  }
  const handleOpenCalendar = () => {
    setOpen(true);
  }
  
  const handleReportCard = (row) => {    
    setSelectedProfileId (row.ete_profile.profileId);
	setSelectedProfileName (row.ete_profile.name);
    setIsPopReportCardOpen(!isPopReportCardOpen);
  };

  const handleGradeSelect = (arg) => {
    setSelectedGrade(
      // On autofill we get a stringified value.
      typeof value === 'string' ? arg.target.value.split(',') : arg.target.value,
    );
  };

  const handleFilterByDate = (event) => {
    setOpen(!filterByDate);
    setFilterByDate(!filterByDate);
  };

  const handleResubmit = (row) => {    
    setEssayId(row.essayId);
    setPopResubmitOpen(true);
  };
  
  const popResubmitClose = (arg) => {
    setPopResubmitOpen(false);   
    setEssayId("");
  }
  const popReportCardClose = () => {
    setSelectedProfileId("");
	setSelectedProfileName("");
    setIsPopReportCardOpen(false);
  }

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    AppHelper.apiAuditPost("P-SA", "");
  }, []);

  const scoreCodesV2_sa = [
    {
      c: "GM",
      c2: "grammar",
      n: "Grammar",
      v: 0,
      p: 0,
      eg: [],
      sub: [],
      expand: false,
    },
    {
      c: "SP",
      c2: "spelling",
      n: "Spelling",
      v: 0,
      p: 0,
      eg: [],
      sub: [],
      expand: false,
    },
    {
      c: "VC",
      c2: "vocabulary",
      n: "Vocabulary",
      v: 0,
      p: 0,
      eg: [],
      sub: [],
      expand: false,
    },
    {
      c: "ST",
      c2: "structure",
      n: "Structure",
      v: 0,
      p: 0,
      eg: [],
      sub: [],
      expand: false,
    },
  ];

  useEffect(() => {
    if (!oUser) {
      navigate("/login");
      return;
    }
  });

  useEffect(() => {
    const fetchEssayList = async () => {
      essayList.splice(0);
      setIsLoading(true);
      var _res = await AppHelper.apiPost("api/essay/list/sa", {
        token: oUser.token,
      });
      if (!_res || !_res.status) {
        setIsLoading(false);
        return;
      }
      _res.data.forEach((r, iRec) => {
        var _ts = dayjs(r.timestampUtc);
        r.rowIndex = 0;
        r.tCode = _ts.format("YYYYMMDDHHmmss");
        r.tTitle = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` + _ts.format('DD MMM YYYY');
        r.viewTitle = `${r.topic}`;
        r.avgScoreP = (r.avgScore / 5) * 100;
        r.email = r.ete_profile ? r.ete_profile.email : "-";
        r.name = r.ete_profile ? r.ete_profile.name : "-";
        r.version = "1.0";
        r.vCorr = r.vCorr ? r.vCorr : "-";
        r.improvedFlag = r.improved != null ? 1 : null;
        if (r.scores && r.scores.length > 0) {
          r.version =
            r.scores[0].version == "3.10"
              ? "3.1"
              : "3.00"
                ? "3.0"
                : "2.20"
                  ? "2.2"
                  : r.scores[0].version == "2.10"
                    ? "2.1"
                    : r.scores[0].version == "2.00"
                      ? "2.0"
                      : "1.0";
          if (r.version == "2.0" || r.version == "2.1" || r.version == "2.2") {
            var _scores = [...scoreCodesV2_sa];
            var _v2TotalScore = 0;
            _scores.forEach((_rScore) => {
              var _arrScRec = r.scores.filter(
                (_x) => _x.scoreCode == _rScore.c
              );
              const _scSum = _arrScRec.reduce(
                (total, current) => total + current.score,
                0
              );
              _v2TotalScore +=
                _arrScRec.length > 0 ? _scSum / _arrScRec.length : 0;
            });
            r.avgScoreP = parseFloat(((r.avgScore / 16) * 100).toFixed(2));
          } else if (r.version == "3.0" || r.version == "3.1") {
            var _scores = [...scoreCodesV2_sa];
            var _v2TotalScore = 0;
            _scores.forEach((_rScore) => {
              var _arrScRec = r.scores.filter(
                (_x) => _x.scoreCode == _rScore.c
              );
              var _scSum = _arrScRec.reduce(
                (total, current) => total + current.score,
                0
              );
              if (_rScore.c == "SP" || _rScore.c == "GM" || _rScore.c == "VC") {
                _scSum = parseFloat((_scSum / 2.5).toFixed(2));
              }
              if (_rScore.c == "VC" && _arrScRec.length < 2) {
                _scSum = parseFloat((_scSum / 2).toFixed(2));
              }
              _v2TotalScore +=
                _arrScRec.length > 0 ? _scSum / _arrScRec.length : 0;
            });
            r.avgScoreP = parseFloat(((r.avgScore / 16) * 100).toFixed(2));
          }
        }
		
      });
      var _list = [...AppHelper.sortList(_res.data, "tCode", 2)];
      updateWithScoreRules(_list);
    };
    const updateWithScoreRules = async (_list) => {
      if (!_list || _list.length < 1) return;
      setIsLoading(true);
      for (var i = 0; i < _list.length; i++) {
        var r = _list[i];
        if (r.version == "3.0" || r.version == "3.1") {
        } //return;
      }
      setEssayList(_list);
      setIsLoading(false);

      setTimeout(() => {
      }, 1000);

      setCountEssay(_list.length);
      if (autoSelectId && autoSelectId != "") {
        var _recEssay = _list.find((r) => r.essayId == autoSelectId);
        if (_recEssay) onEssaySelect(_recEssay);
        setAutoSelectId("");
      }

      if (pageEssayId) {
        var _pageEssay = _list.find((r) => r.essayId == pageEssayId);
        if (_pageEssay) {
          essayViewClick(_pageEssay);
        }
      }
    };

    const fetchIAM = async () => {
      if (!oUser) {
        navigate("/login");
        return;
      }
      var _res = await AppHelper.apiPost("api/account/iam", {
        token: oUser.token,
      });
      if (!_res || !_res.status || !_res.data || !_res.data.isSa) {
        setIsLoading(false);
        nonSaView();
        return;
      }
      fetchEssayList();
    };
    fetchIAM();
    //fetchEssayList();
  }, [refreshList]);

  const onEssaySelect = (arg) => {
    setViewMode("VIEW");
    setRecEssay(arg);
    var _list = essayList;
    _list.forEach((s) => {
      s.selected = s.essayId == arg.essayId ? "1" : "0";
    });
  };
  const essayDelete = async (arg) => {
    if (!window.confirm("Are you sure you want to delete the Essay?")) return;
    setIsLoading(true);
    var _res = await AppHelper.apiPost("api/essay/remove", {
      token: oUser.token,
      essayId: arg.essayId,
    });
    if (!_res || !_res.status) {
      alert("ERROR: Failed to delete!");
      setIsLoading(false);
      return;
    }
    setRefreshList(!refreshList);
  };
  const essayFormDone = (arg) => {
    if (arg.code && arg.code == "NEW") {
      setAutoSelectId(arg.essayId);
    }
    setRefreshList(!refreshList);
  };
  const essayViewClick = (arg) => {
    setRecEssay(arg);
    setViewMode("VIEW");
  };
  const essayViewDone = (arg) => {
    setRefreshList(!refreshList);
    setViewMode("NEW");
  };
  const essayListView = () => {
    //setViewMode("LIST");
    navigate("/saV2/essay");
  };

  const cardView = () => {
    navigate("/sa");
  };
  const viewDraftPreview = (essayId) => {
    setEssayId(essayId);
    setOpenDraftPreview(true);
  };
  const onDraftPreviewClose = () => {
    setOpenDraftPreview(false);
  };
  
  const nonSaView = () => {
    setViewMode("NON-SA");
  };
  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };
  const back2Home = () => {
    navigate("/");
  };
  const listSortAndFilterEssay = () => {
    var _list = [...essayList];
    if (filterEssay && filterEssay.length > 0) {
      var _filterText = filterEssay.toLowerCase();
      _list = _list.filter(
        (r) =>
          r.grade.toLowerCase().includes(_filterText) ||
          r.topic.toLowerCase().includes(_filterText) ||
          r.email.toLowerCase().includes(_filterText) ||
          r.version.toLowerCase().includes(_filterText) ||
          r.tTitle.toLowerCase().includes(_filterText) ||
          r.avgScoreP.toString().toLowerCase().includes(_filterText)
      );
    }

    if (statusFilter != 'not0' && statusFilter != 'all' && statusFilter != 'improved') {
      _list = _list.filter(
        (r) =>
          r.status == statusFilter
      );
    }
    else if (statusFilter == 'not0') {
      _list = _list.filter(
        (r) =>
          r.status != 0 && r.status != 5
      );
    }
    else if (statusFilter == 'improved') {
      _list = _list.filter(
        (r) =>
          r.improved != null
      );
    }

    if (selectedGrade.length > 0) {
      _list = _list.filter((r) => selectedGrade.includes(r.grade));
    }

    if (filterByDate && dateRange[0] && dateRange[1]) {
      const startMs = dateRange[0].startOf('day').valueOf();
      const endMs   = dateRange[1].endOf('day').valueOf();
      _list = _list.filter(r => {
        const ts = dayjs(r.timestampUtc).valueOf();
        return ts >= startMs && ts <= endMs;
      });
    }
	setPage(0);

    return stableSort(_list, getComparator(tblOrderEssay, tblOrderByEssay));
  };
  const filterEssayChange = (event) => {
    setFilterEssay(event.target.value);
  };

  const visibleEssays = React.useMemo(
    () => listSortAndFilterEssay(),
    [essayList, tblOrderEssay, tblOrderByEssay, filterEssay, statusFilter, selectedGrade, dateRange, filterByDate]
  );
  const tblSortEssay = (event, property) => {
    const isAsc = tblOrderByEssay === property && tblOrderEssay === "asc";
    setTblOrderEssay(isAsc ? "desc" : "asc");
    setTblOrderByEssay(property);
  };

  const handleResubmitPosted = (newEssayId) => {
    setPopResubmitOpen(false);
    setEssayId("");
    essayFormDone({ code: "NEW", essayId: newEssayId });
    navigate(`/essay/detail/${newEssayId}`);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
      {isLoading ? (
        <AppLoading />
      ) : (
        <>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: "100%",
              marginTop: "50px",
            }}
          >

            {viewMode == "LIST" && (
              <>
                <Grid container xs={16} alignItems="center" justifyContent="space-between"
                sx={{mb: '5px'}}>
				  <Grid item xs={1.8} sm={1.8}>
					<Button onClick={cardView}>&laquo; Back to Overview</Button>
				  </Grid>

          <Grid item xs={2.1} sm={2.1} >
            <div>
              <FormControl sx={{ width: 200 }}>
                <InputLabel>Select Grade</InputLabel>
                <Select
                  multiple
                  value={selectedGrade}
                  onChange={handleGradeSelect}
                  input={<OutlinedInput label="Select Grade" />}
                  renderValue={(selected) => {
                    const max = 3;
                    const visible = selected.slice(0, max);
                    const hiddenCount = selected.length - max;
                    return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {visible.map((value) => (
                        <Chip key={value} label={value} size="small" />
                      ))}
                      {hiddenCount > 0 && (
                        <Chip label={`+${hiddenCount}`} size="small"/>
                      )}
                    </Box>
                    )
                  }}
                >
                  {gradeList.map((grade) => (
                    <MenuItem key={grade} value={grade}>
                      <Checkbox checked={selectedGrade.includes(grade)} />
                      <ListItemText primary={grade} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
				  </Grid>
          <Grid item xs={5} sm={5} sx={{ display: 'flex', ml: '10px' }}>
            <FormControlLabel
            ref={anchorRef}
            control={
              <Checkbox
              color="primary"
              checked={filterByDate}
              onChange={handleFilterByDate}
              />
              }
              label="Filter by date range"
              sx={{paddingRight: "1rem"}}
            />

            {!open && filterByDate &&
            <Box 
              sx={{
                display: 'flex', 
                justifyContent: 'flex-end', 
                gap: 1, 
                p: 1, 
                border: 1, 
                borderColor: 'divider', 
                borderRadius: 1, 
                bgcolor: 'background.paper'}}>
              <Button size="small" onClick={handleOpenCalendar}>
                {`${dateRange[0].format('DD/MM/YYYY')} – ${dateRange[1].format('DD/MM/YYYY')}`}
              </Button>
             </Box>
            }

            {filterByDate && 
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="right-start"
                style={{ zIndex: 1300 }}
              >
                <ClickAwayListener onClickAway={handleCloseCalendar}>

            <Box
              sx={{
              boxShadow: 3,
              bgcolor: 'background.paper',
              borderRadius: 1,
              overflow: 'hidden',
              '& .rdrDefinedRangesWrapper': {
                display: 'none !important',
              },
              '& .rdrDateRangeWrapper': {
                gridTemplateColumns: '0px auto !important',
              },
              '& .rdrInRange, & .rdrStartEdge, & .rdrEndEdge, & .rdrSelected': {
                background: 'rgba(19,130,117,1) !important',
              },
              }}
            >
                <DateRangePicker 
                ranges={[{
                  startDate: startDate.toDate(), 
                  endDate: endDate.toDate(), 
                  key: 'selection'
                }]}
                onChange={item => {
                  const sel = item.selection;
                  setStartDate(dayjs(sel.startDate));
                  setEndDate(dayjs(sel.endDate));
                  setDateRange([dayjs(sel.startDate), dayjs(sel.endDate)]);
                }}
                direction="vertical"
                months={1}        
                showDateDisplay={false}
                maxDate={new Date()}  
                  staticRanges={[]}
                  inputRanges={[]}
              />
             
             <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
              <Button size="small" onClick={handleCloseCalendar} sx={{color: "rgba(19,130,117,1)"}}>
                Close
              </Button>
             </Box>
            </Box>
            </ClickAwayListener>
            </Popper>
            }
				  </Grid>

				  <Grid item xs={3} sm={3} style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px' }}>
					<TextField
					  value={filterEssay}
					  onChange={filterEssayChange}
					  id="txtFilterEssay"
					  label=""
					  variant="standard"
					  placeholder="Search"
					  style={{ minWidth: '150px' }}
					/>
					
					<FormControl variant="standard">
					  <Select
						labelId="status-filter-label"
						id="status-filter"
						value={statusFilter}
						onChange={handleStatusFilterChange}
						label="Filter by Status"
					  >
						<MenuItem value="all">All Status</MenuItem>
						<MenuItem value="0">Draft</MenuItem>
						<MenuItem value="5">Successful</MenuItem>
						<MenuItem value="not0">Failed</MenuItem>
						<MenuItem value="improved">Improved</MenuItem>
					  </Select>
					</FormControl>
				  </Grid>
				</Grid>

                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650}} aria-label="simple table">
                    <EnhancedTableHead
                      order={tblOrderEssay}
                      orderBy={tblOrderByEssay}
                      onRequestSort={tblSortEssay}
                      rowCount={essayList.length}
                      gid="G1"
                    />
                    <TableBody>
                      {visibleEssays
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, iRec) => (
                          <TableRow
                            key={row.essayId}
                            sx={{
                            }}
                          >
                            <TableCell align="center">{iRec + 1}.</TableCell>
                            <TableCell align="left">{row.grade}</TableCell>
                            <TableCell component="th" scope="row">
							  <div style={{ display: "flex", alignItems: "center" }}>
								{row.status === 0 ? (
								  <>				
									<Button
                    onClick={() => viewDraftPreview(row.essayId)}
									  style={{
                    padding: "2px 8px",
                    borderRadius: "5px",
                    textTransform: 'none'
									  }}
									>
									  <span
									  style={{
										backgroundColor: "#1976d2",
										color: "white",
										padding: "2px 8px",
										borderRadius: "5px",
										marginRight: "3px",
										fontSize: "0.7rem",
									  }}
									>
									  Draft
									</span>
									</Button>
								  <>				
								  </>
								  </>
								) : row.status === 5 ? (
								  <>									
									<Button
									  href={"/essay/detail/" + row.essayId}
									  target="_blank"
									  style={{
										borderRadius: "5px",
										padding: "5px 10px",
                    textTransform: 'none'
									  }}
									>
									  {row.topic}
									</Button>
								  </>
								) : (
								  <>
									<span
									  style={{
										backgroundColor: 
                        (new Date() - new Date(row.timestampUtc)) / (1000 * 60) < 10 
                        ? "rgba(19,130,117,1)" : "#d32f2f", // Red color for non-draft, non-successful statuses
										color: "white",
										padding: "2px 8px",
										borderRadius: "5px",
										marginRight: "3px",
										fontSize: "0.7rem",
									  }}
									>
									  {(new Date() - new Date(row.timestampUtc)) / (1000 * 60) < 10
                      ? "Processing" : "Failed"}
									</span>
									<Button
									  href={"/essay/detail/" + row.essayId}
									  target="_blank"
									  style={{
										borderRadius: "5px",
										padding: "5px 10px",
                    textTransform: 'none'
									  }}
									>
									  {row.topic}
									</Button>
								  </>
								)}
							  </div>
							</TableCell>

                            <TableCell>
                              {row.improved && row.improved.length > 0 && (
                                <Box
                                  component="div"
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1, 
                                    mb: 1, 
                                  }}
                                >
                                  <AutoFixHighIcon sx={{ color: '#6451a9' }} />
                                  <Box component="div">
                                    {row.improved.map((imp, idx) => (
                                      <Box key={idx} sx={{ mb: idx < row.improved.length - 1 ? 1 : 0 }}>
                                        {imp.improvedByLink?.includes("/share") ? (
                                        <Typography variant="body2">
                                          {imp.impProfile?.name} (<a href={imp.improvedByLink}>via Shared Link</a>)
                                        </Typography>
                                        ) : (
                                        <Typography variant="body2">
                                          {imp.impProfile?.name}
                                        </Typography>
                                        )
                                        }
                                        <Typography variant="body2">
                                          {imp.impProfile?.email}
                                        </Typography>
                                      </Box>
                                    ))}
                                  </Box>
                                </Box>
                              )}

                              {/* Put Improved or not here */}
                            </TableCell>
                            <TableCell align="right">
                              {row.avgScore.toFixed(2)}
                            </TableCell>
                            <TableCell align="right">
                              <Tooltip 
                                arrow
                                title={
                                  <div style={{whiteSpace: 'pre-line'}}>
                                    Evaluation Version
                                  </div>
                                }
                              >
                              <Chip 
                                label={`v${row.vEval}`}
                                style={{
                                  height: '25px', 
                                  fontSize:'12px', 
                                  alignItems: 'right', 
                                  justifyContent: 'right',  
                                }} />
                              </Tooltip>
                              <br/>
                              <Tooltip 
                                arrow
                                title={
                                  <div style={{whiteSpace: 'pre-line'}}>
                                    Correction Version
                                  </div>
                                }
                              >
                              <Chip 
                                label={`v${row.vCorr}`}
                                style={{
                                  height: '25px', 
                                  fontSize:'12px', 
                                  alignItems: 'right', 
                                  justifyContent: 'right',  
                                  marginTop: '10px', 
                                }} />
                              </Tooltip>
                            </TableCell>
                            <TableCell align="left">{row.tTitle}</TableCell>
                            <TableCell align="left">
                              {row.ete_profile ? row.ete_profile.name : "-"}
                              <br/>
                              {row.ete_profile ? row.ete_profile.email : "-"}
                            </TableCell>
                            <TableCell align="left">
								 <IconButton onClick={() => handleReportCard(row)}>
									<Leaderboard />
								</IconButton>
							  
                              <IconButton
                                onClick={() => essayDelete(row)}
                                aria-label="delete"
                              >
                                <DeleteForeverIcon color="error" />
                              </IconButton>
                              <IconButton
                                onClick={() => handleResubmit(row)}
                                aria-label="Re-submit"
                              >
                                <RestartAltRoundedIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={visibleEssays.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </>
            )}

            {viewMode == "VIEW" && (
              <>
                <Box>
                  <Button onClick={essayListView}>&laquo; Back to List</Button>
                </Box>
                <EssayView
                  essayFormDone={essayViewDone}
                  essayId={recEssay.essayId}
                ></EssayView>
              </>
            )}
            {viewMode == "NON-SA" && (
              <React.Fragment>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Card variant="outlined">
                      <CardContent>
                        <Typography variant="h5" component="div">
                          Access denied
                        </Typography>
                        <Typography sx={{ mb: 1.5 }} color="text.secondary">
                          &nbsp;
                        </Typography>
                        <Typography variant="body2">
                          This page is only allowed for System Administrators.
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Button onClick={back2Home} size="small">
                          Back to Home
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                </Grid>
              </React.Fragment>
            )}
          </Box>
        </>
      )}
      <SpaCheck></SpaCheck>
	   <PopReportCard
        open={isPopReportCardOpen} profileName={selectedProfileName} profileId={selectedProfileId} onClose={popReportCardClose}
      />
    <PopResubmit
      recEssay={recEssay}
      open={popResubmitOpen}
      onClose={popResubmitClose}
      essayId={essayId}
      onResubmitPosted={handleResubmitPosted}
    />
    <PopDraftPreview
      open={openDraftPreview}
      onClose={onDraftPreviewClose}
      essayId={essayId}
    />
    </Box>
  );
}
